import React, { Fragment } from 'react';
import styled from 'styled-components';
import Helmet from 'react-helmet';

import FlashIt from '~/views/common/FlashIt/index.js';
import LoginForm from '../containers/LoginForm.jsx';

import logoSVG from '~/images/starkiller.svg';


const Star = styled.div`
    font-size: 5rem;
    font-weight: bold;
    line-height: 5rem;
    color: #FFE519;
`;

const Base = styled.div`
    font-size: 2rem;
    line-height: 2rem;
    color: #FFE519;
`;

const Heading = styled.header`
    padding: 4rem 0;
    padding-left: ${p => p.theme.margin.gutters};
    background-color: ${p => p.theme.color.black};
`;

const Main = styled.main`
    max-width: 500px;
    padding: 2rem 0;
    padding-left: ${p => p.theme.margin.gutters};
`;

const Logo = styled.img.attrs({
    src: logoSVG,
    alt: 'StarkillerBase logo',
})`
    height: 200px;
    width: auto;
    margin-bottom: 1rem;
`;

const Login = () => (
    <Fragment>
        <Helmet title="Login" />

        <FlashIt />

        <Heading>
            <Logo />
            <Star>STARKILLER</Star>
            <Base>BASE</Base>
        </Heading>

        <Main>
            <LoginForm />
        </Main>
    </Fragment>
);

export default Login;
